import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import clsx from 'clsx';
import { Icon } from '../../../../layout/Icon.jsx';

const PRESETS = [
  { days: 30, label: 'شهر' },
  { days: 60, label: 'شهران' },
  { days: 90, label: '3 أشهر' },
  { days: 180, label: '6 أشهر' },
  { days: 365, label: 'سنة' }
];

function defaultsFrom(plan) {
  return {
    name: plan?.name || '',
    price: plan?.price ?? 50000,
    durationDays: plan?.durationDays ?? 30,
    description: plan?.description || '',
    isActive: plan?.isActive !== false
  };
}

export function PlanForm({ open, plan, onClose, onSubmit, submitting }) {
  const isEdit = !!plan;
  const {
    register, handleSubmit, reset, watch, setValue,
    formState: { errors }
  } = useForm({ defaultValues: defaultsFrom(plan) });

  useEffect(() => {
    if (open) reset(defaultsFrom(plan));
  }, [open, plan, reset]);

  const days = Number(watch('durationDays')) || 0;

  if (!open) return null;

  const submit = (values) => {
    const name = (values.name || '').trim();
    if (name.length < 2) return;
    if (!(Number(values.durationDays) >= 1)) return;
    onSubmit?.({
      name,
      price: Number(values.price) || 0,
      durationDays: Math.max(1, Math.round(Number(values.durationDays) || 0)),
      description: values.description || '',
      isActive: !!values.isActive
    });
  };

  return (
    <div className="fixed inset-0 z-50 grid place-items-center p-4" style={{ background: 'rgba(0,0,0,.45)' }}>
      <form
        className="card w-[540px] max-w-full max-h-[92vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
        onSubmit={handleSubmit(submit)}
        noValidate
      >
        <div className="card-h">
          <h3 className="text-[15px] font-bold flex-1">
            {isEdit ? 'تعديل باقة اشتراك شهري' : 'باقة اشتراك شهري جديدة'}
          </h3>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            <Icon name="x" size={14} />
          </button>
        </div>

        <div className="card-b space-y-3">
          <div>
            <label className="block text-xs font-semibold text-ink-2 mb-1">الاسم *</label>
            <input
              className={clsx('input', errors.name && 'border-red')}
              placeholder="مثلاً: اشتراك شهر — دخول غير محدود"
              {...register('name', { required: true })}
            />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-semibold text-ink-2 mb-1">السعر (د.ع) *</label>
              <input
                className="input"
                type="number"
                min="0"
                {...register('price', { valueAsNumber: true, required: true })}
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-ink-2 mb-1">المدة (يوم) *</label>
              <input
                className="input"
                type="number"
                min="1"
                {...register('durationDays', { valueAsNumber: true, required: true })}
              />
            </div>
          </div>

          <div className="flex flex-wrap gap-1.5">
            {PRESETS.map((p) => (
              <button
                key={p.days}
                type="button"
                onClick={() => setValue('durationDays', p.days, { shouldDirty: true })}
                className={clsx(
                  'px-3 py-1.5 rounded-[8px] text-[12px] font-semibold border transition-colors',
                  days === p.days
                    ? 'bg-orange text-white border-orange'
                    : 'bg-white text-ink-2 border-line hover:bg-paper-2'
                )}
              >
                {p.label}
              </button>
            ))}
          </div>

          <div
            className="rounded-[10px] px-3 py-2 text-[12px]"
            style={{ background: '#FFFCF5', border: '1px solid #F2E6CC', color: '#8A5A12' }}
          >
            الاشتراك الشهري مستقل عن التسعير بالساعة والباقات الزمنية: المشترك يدخل
            بلا رسوم لعب خلال فترته، ويبقى يدفع الكافتيريا والألعاب والمرافقين كالمعتاد.
          </div>

          <div>
            <label className="block text-xs font-semibold text-ink-2 mb-1">الوصف</label>
            <textarea className="input" rows={2} {...register('description')} />
          </div>

          <label className="flex items-center gap-2 cursor-pointer text-[13px] text-ink-2">
            <input type="checkbox" className="accent-orange" {...register('isActive')} />
            فعّالة (تظهر عند تسجيل اشتراك جديد)
          </label>
        </div>

        <div className="card-h border-b-0 border-t flex justify-end gap-2">
          <button type="button" className="btn" onClick={onClose} disabled={submitting}>إلغاء</button>
          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? 'جاري الحفظ...' : isEdit ? 'حفظ' : 'إنشاء'}
          </button>
        </div>
      </form>
    </div>
  );
}
